module.exports = __webpack_public_path__ + "img/Mask Group 130.05de3162.svg";